import { /* ErrorMessage, */ Field, Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import Cookies from 'universal-cookie';

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Alert,
  Spinner,
} from 'reactstrap';
import { login } from '../../store';
import axios from 'utils/axios';
import * as Yup from 'yup';
import { createUseStyles } from 'react-jss';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { startsWith } from 'lodash-es';
import AntButton from 'antd/lib/button';
import 'antd/lib/button/style/index.css';
import OtpInput from 'react-otp-input';

/* ----------------Styles-------------- */
const useStyles = createUseStyles({
  signInButton: {
    width: '100%',
    backgroundColor: '#2675b8',
    color: 'white',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
    border: 'none',
  },
  forgotPassword: {
    '&:hover': {
      textDecoration: 'underline',
      color: '#b4b5be',
    },
    paddingLeft: '3px',
    color: '#b4b5be',
  },
  createAccount: {
    '&:hover': {
      textDecoration: 'underline',
      color: '#b4b5be',
    },
    paddingRight: '3px',
    color: '#b4b5be',
  },
  loginWithOTP: {
    '&:hover': {
      textDecoration: 'none',
      color: '#2675b8',
      border: 'none',
    },

    color: '#2675b8',
    boxShadow: 'none',
    border: 'none',
    backgroundColor: '#f7fafc',
  },
  phoneInput: {
    backgroundColor: 'black',
  },
  signinButton: {
    marginTop: '4px',
    height: '43px',
    backgroundColor: '#2675b8',
    width: '100%',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    '&:focus': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    borderRadius: '5px',
  },
});

const Login = () => {
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showOTPBlock, setShowOTPBlock] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isSendingOTP, setSendingOTP] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (error)
      setTimeout(() => {
        setError('');
      }, 4000);
  }, [error]);

  const LoginSchema = Yup.object().shape({
    username: Yup.string(),
    password: Yup.string(),
  });

  const handleSubmit = async (
    { username, password, otp },
    { setSubmitting },
  ) => {
    try {
      setError('');
      const formattedUsername = startsWith('+', username)
        ? username
        : `+${username}`;
      let request = null;
      if (showOTPBlock) {
        if (!otp) {
          setError('Please enter OTP');
        } else {
          request = {
            phone: formattedUsername,
            otp,
          };
        }
      } else {
        if (!password) {
          setError('Invalid credentials');
        } else {
          request = {
            username: formattedUsername,
            password,
          };
        }
      }
      if (!request) return;
      const apiURL = showOTPBlock ? '/users/otploginConfirm' : '/users/logIn';
      const { data } = await axios.post(apiURL, request);

      const { idToken, refreshToken, accessToken } = data;
      const cookies = new Cookies();
      cookies.remove('jp_idtoken');
      cookies.remove('jp_refreshtoken');
      cookies.remove('jp_accesstoken');
      if (showOTPBlock) {
        cookies.set('jp_idtoken', idToken.jwtToken, {
          path: '/',
        });
        cookies.set('jp_refreshtoken', refreshToken.token, {
          path: '/',
        });
        cookies.set('jp_accesstoken', accessToken.jwtToken, {
          path: '/',
        });
        login(jwt_decode(idToken.jwtToken));
      } else {
        cookies.set('jp_idtoken', idToken, {
          path: '/',
        });
        cookies.set('jp_refreshtoken', refreshToken, {
          path: '/',
        });
        cookies.set('jp_accesstoken', accessToken, {
          path: '/',
        });
        login(jwt_decode(idToken));
      }
      setShowOTPBlock(false);
    } catch (error) {
      if (error.response?.data?.message) {
        setError(error.response.data.message);
      } else {
        setError('Login failed');
      }
    } finally {
      setSubmitting(false);
    }
  };

  const timerRef = useRef(null);

  const sendOTPtoPhone = async (phone) => {
    if (!phone || phone === '91') setError('Please enter phone no.');
    else {
      const request = {
        phone: startsWith('+', phone) ? phone : `+${phone}`,
      };
      setSendingOTP(true);
      const { data } = await axios.post('/users/otpLogin', request);
      const { message } = data;
      if (message === 'OTP sent successfully to your mobile') {
        setSendingOTP(false);
        setShowOTPBlock(true);
        setTimer(60);
        startTimer();
      }
    }
  };

  const startTimer = () => {
    let initialTimer = 60;
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimer(initialTimer - 1);
      initialTimer -= 1;
      if (initialTimer <= 0) clearInterval(timerRef.current);
    }, 1000);
  };

  const cancelOTPLogin = () => {
    setTimer(0);
    setShowOTPBlock(false);
    clearInterval(timerRef.current);
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '445px',
          alignItems: 'center',
        }}
      >
        <Card
          className="bg-secondary shadow border-0"
          style={{ width: '100%' }}
        >
          <CardHeader className="">
            <div to="/" tag={Link} className="text-muted text-center mt-2 mb-3">
              <img
                alt="..."
                src={require('../../assets/companyLogo/jplogo.png').default}
                style={{ width: '180px' }}
              />
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            {error ? (
              <div className="text-center text-muted mb-4">
                <Alert className="m-3" variant="danger">
                  {error}
                </Alert>
              </div>
            ) : null}

            <Formik
              initialValues={{
                username: '',
                password: '',
                otp: '',
              }}
              onSubmit={handleSubmit}
              validationSchema={LoginSchema}
            >
              {({
                values,
                isSubmitting,
                setFieldValue,
                errors,
                handleSubmit,
              }) => (
                <Form>
                  {!showOTPBlock && (
                    <>
                      <FormGroup className="mb-3">
                        <PhoneInput
                          name="username"
                          country={'in'}
                          placeholder="Phone Number with country code"
                          value={values.username}
                          onChange={(phone) => {
                            setFieldValue('username', phone);
                            setError('');
                          }}
                          inputStyle={{ width: '100%', height: '43px' }}
                          countryCodeEditable={false}
                          enableSearch={true}
                        />
                      </FormGroup>
                      <FormGroup>
                        <InputGroup
                          className="input-group-alternative"
                          style={{
                            boxShadow: 'none',
                            border: '0.5px solid #cfcfcf',
                            borderRadius: '3px',
                          }}
                        >
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-lock-circle-open" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Field
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            className="form-control"
                            placeholder="Password"
                            disabled={isSubmitting}
                            onKeyPress={(e) => {
                              if (e.charCode === 13) handleSubmit();
                            }}
                          />
                          <InputGroupAddon addonType="append">
                            <InputGroupText>
                              <i
                                className={`fa ${
                                  showPassword ? 'fa-eye-slash' : 'fa-eye'
                                }`}
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ cursor: 'pointer' }}
                              />
                            </InputGroupText>
                          </InputGroupAddon>
                          {/* <ErrorMessage
                        name="password"
                        component="small"
                        className="form-text text-danger"
                      /> */}
                        </InputGroup>
                      </FormGroup>
                    </>
                  )}

                  {showOTPBlock && (
                    <>
                      <div className="text-center">
                        <small>
                          {' '}
                          Please enter the OTP you received on your phone number
                          +{values.username}
                        </small>
                      </div>
                      <FormGroup className="mb-3">
                        <Field
                          component={OtpInput}
                          className="otp"
                          value={values.otp}
                          onChange={(value) => {
                            setFieldValue('otp', value);
                          }}
                          numInputs={6}
                          separator={<span>-</span>}
                          inputStyle={{ width: 40, height: 40, margin: 7 }}
                          onKeyPress={(e) => {
                            if (e.charCode === 13) handleSubmit();
                          }}
                        />
                      </FormGroup>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div>
                          {timer <= 0 ||
                            (true && (
                              <>
                                <small>Didn't received the code?</small>
                                &nbsp;&nbsp;
                                <Link
                                  className={classes.loginWithOTP}
                                  onClick={() => {
                                    sendOTPtoPhone(values.username);
                                    setFieldValue('otp', '');
                                  }}
                                >
                                  <small>Resend OTP</small>
                                </Link>
                                {isSendingOTP && (
                                  <Spinner
                                    style={{
                                      color: '#2675b8',
                                      fontSize: 5,
                                      marginLeft: 10,
                                      marginTop: 5,
                                    }}
                                    size="sm"
                                  />
                                )}
                              </>
                            ))}
                        </div>

                        <div>
                          {timer > 0 && `00:${timer < 10 ? '0' : ''}${timer}`}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="text-center">
                    <AntButton
                      className={classes.signinButton}
                      loading={isSubmitting}
                      htmlType="submit"
                      onClick={() => console.log(errors)}
                    >
                      {showOTPBlock ? 'Submit' : 'Sign in'}
                    </AntButton>
                  </div>
                  {showOTPBlock ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <Link
                        to="#"
                        className={classes.loginWithOTP}
                        onClick={() => {
                          cancelOTPLogin();
                        }}
                      >
                        <small>Cancel</small>
                      </Link>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <Link
                        to="#"
                        className={classes.loginWithOTP}
                        onClick={() => {
                          sendOTPtoPhone(values.username);
                        }}
                      >
                        <small>Login with OTP</small>
                      </Link>
                      {isSendingOTP && (
                        <Spinner
                          style={{
                            color: '#2675b8',
                            fontSize: 5,
                            marginLeft: 10,
                            marginTop: 5,
                          }}
                          size="sm"
                        />
                      )}
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '445px',
            marginTop: '15px',
          }}
        >
          <Link className={classes.createAccount} to={`/auth/forgotPassword`}>
            <small>Forgot password?</small>
          </Link>

          <Link className={classes.createAccount} to="/auth/signup">
            <small>Create new account</small>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Login;
